import React from "react";
import PropTypes from "prop-types";
import { Snackbar } from "@material-ui/core";

const SnackbarComponent = (props) => (
  <Snackbar
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    open={props.snackBarStatus}
    message={<span id="message-id">{props.snackBarMessage}</span>}
  />
);

SnackbarComponent.propTypes = {
  snackBarStatus: PropTypes.bool,
  snackBarMessage: PropTypes.string,
};

export default SnackbarComponent;
